import back_seek_button from '../assets/seek_backward_15.png';
import forward_seek_button from '../assets/seek_forward_15.png';
import play_button from '../assets/play_button.png';
import pause_button from '../assets/pause_button.png';
import { useState, useEffect, useRef } from 'react';

import chapter_1_mockup from '../assets/born_in_1946_mockup.png';
import chapter_2_mockup from '../assets/year_in_america_mockup.png';
import chapter_3_mockup from '../assets/summer_haven_mockup.png';

export default function AudioPlayer(props) {
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const audioRef = useRef(null);

    // Initialize audio element and set up event listeners
    useEffect(() => {
        const audio = document.getElementById('player');
        audioRef.current = audio;
        
        // Update time and duration when metadata is loaded
        audio.addEventListener('loadedmetadata', () => {
            setDuration(audio.duration);
        });
        
        // Update current time as audio plays
        audio.addEventListener('timeupdate', () => {
            setCurrentTime(audio.currentTime);
        });
        
        // Reset playing state when audio ends
        audio.addEventListener('ended', () => {
            setIsPlaying(false);
        });
        
        // Clean up event listeners on unmount
        return () => {
            audio.removeEventListener('loadedmetadata', () => {});
            audio.removeEventListener('timeupdate', () => {});
            audio.removeEventListener('ended', () => {});
        };
    }, []);

    function playAudio() {
        setIsPlaying(true);
        audioRef.current.play();
    }
    
    function pauseAudio() {
        setIsPlaying(false);
        audioRef.current.pause();
    }
    
    function backSeekAudio() {
        audioRef.current.currentTime = Math.max(0, audioRef.current.currentTime - 15);
    }
    
    function forwardSeekAudio() {
        audioRef.current.currentTime = Math.min(audioRef.current.duration, audioRef.current.currentTime + 15);
    }
    
    // Handle manual seeking when user drags the slider
    function handleSeek(e) {
        const newTime = parseFloat(e.target.value);
        audioRef.current.currentTime = newTime;
        setCurrentTime(newTime);
    }
    
    // Format time as MM:SS
    function formatTime(timeInSeconds) {
        if (isNaN(timeInSeconds)) return "00:00";
        
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = Math.floor(timeInSeconds % 60);
        
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    let mockup_img = chapter_1_mockup
    let audio_url = `/audio/frogs_in_bag.mp3`
    if (props.chapterId === 2) {
        mockup_img = chapter_2_mockup
        audio_url = `/audio/year_in_america.mp3`
    } else if (props.chapterId === 3) {
        mockup_img = chapter_3_mockup
        audio_url = `/audio/summer_haven.mp3`
    }

    const handleContainerClick = (e) => {
        e.stopPropagation();
    };
    
    return (
        <div className="opaque-overlay" onClick={props.onClose}>
            <div className="audio-player-container" onClick={handleContainerClick}>
                <button className="modal-close-button" onClick={props.onClose}>X</button>
                <img src={mockup_img} className="audio-player-chapter-image" />
                <div className="audio-player-title-container">
                    <h1 className="chapter-sample-title">Chapter {props.chapterId}</h1>
                    <h2 className="chapter-sample-subtitle">{props.chapterTitle}</h2>
                </div>
                
                
                <audio id="player" src={audio_url}></audio>
                
                <div className="audio-player-seeker-container">
                    <input
                        type="range"
                        className="audio-player-seeker-range"
                        min="0"
                        max={duration || 100} // Default to 100 if duration not loaded yet
                        value={currentTime}
                        onChange={handleSeek}
                    />
                    <div className="audio-player-seeker-value">
                        {formatTime(currentTime)} / {formatTime(duration)}
                    </div>
                </div>
                
                <div className="audio-player-controls-container">
                    <img onClick={backSeekAudio} src={back_seek_button} className="audio-player-back-seek-button" />
                    {
                        isPlaying ? 
                            <img onClick={pauseAudio} src={pause_button} className="audio-player-play-pause-button" /> : 
                            <img onClick={playAudio} src={play_button} className="audio-player-play-pause-button" />
                    }
                    <img onClick={forwardSeekAudio} src={forward_seek_button} className="audio-player-forward-seek-button" />
                </div>
            </div>
        </div>
    )
}